// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Callout = require("../../common/Components/Callout.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function PropertyWizardRelay__PriceDropCallout(props) {
  let onDismiss = props.onDismiss;
  return JsxRuntime.jsx(Callout.Info.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "The goal of price reduction broadcasts is to give TAN members advance notice."
        }),
        JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
          onClick: param => onDismiss(),
          size: "small",
          children: "Got it",
          color: "TanBlue"
        })
      ],
      className: "flex flex-col gap-6 items-start"
    }),
    title: "Please ensure the price drop isn't already in the MLS"
  });
}

let make = PropertyWizardRelay__PriceDropCallout;

exports.make = make;
/* Callout Not a pure module */
